import Swiper, { Navigation, FreeMode, A11y } from 'swiper'
Swiper.use([Navigation, FreeMode, A11y])

import 'swiper/css'

export const swiperGlobal = () => {

  const sliders = document.querySelectorAll('[data-swiper-global]')

  if (!sliders.length) return

  sliders.forEach(slider => {

    const nextEl = slider.parentElement.querySelector('.next')
    const prevEl = slider.parentElement.querySelector('.prev')

    new Swiper(slider, {
      slidesPerView: 'auto',
      centeredSlides: true,
      freeMode: {
        enabled: true,
        momentum: true,
        sticky: true
      },
      navigation: {
        nextEl,
        prevEl 
      },
      breakpoints: {
        651: {
          centeredSlides: false
        },
      }
    })

  })


}

export default () => {}